import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Nav from './nav';
import OrganisationSelector from './organisationSelector';
import AdminActions from './adminActions';
import { Maintenance } from 'front-onceforall-core';
import { globalContextPages } from '../../../App';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const OrganisationHeaderView = props => {
  const shouldHideOrganisationHeader = globalContextPages.includes(props.location.pathname);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.organisation && !shouldHideOrganisationHeader && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "organisation-bar",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex-container",
          children: [/*#__PURE__*/_jsx(OrganisationSelector, {}), /*#__PURE__*/_jsx(Nav, {})]
        }), /*#__PURE__*/_jsx("div", {
          className: "action-bar",
          children: /*#__PURE__*/_jsx(AdminActions, {})
        })]
      }), /*#__PURE__*/_jsx(Maintenance, {
        class: "card mt-4",
        maintenance: props.maintenance,
        currentLocale: props.currentLocale
      })]
    })
  });
};
OrganisationHeaderView.propTypes = {
  location: PropTypes.object.isRequired,
  organisation: PropTypes.object,
  shouldHideOrganisationHeader: PropTypes.bool,
  currentLocale: PropTypes.string.isRequired,
  maintenance: PropTypes.object
};
function mapStateToProps(state) {
  return {
    organisation: state.organisation,
    organisationLogo: state.organisationLogo,
    currentLocale: state.i18n.locale,
    maintenance: state.maintenance
  };
}
export default withRouter(connect(mapStateToProps)(OrganisationHeaderView));